import { Loading } from 'src/shared/components/ui/loaders/loading';

export default function LoadingPage({ testId }: { testId?: string }) {
  return (
    <div data-testid={testId} className="w-[100vw] h-[100vh] flex justify-center items-center grid-container">
      <Loading size={32} color="grey" />
    </div>
  );
}
